export interface EmailConfigModel {
    emailConfigID: number,
    from: string,
    username: string,
    password: string,
    host: string,
    port: number,
    defaultCredentials: boolean,
    enableSsl: boolean,
    createdBy: number,
    createdAt: string | null,
    dirtyFields: string[]
}

export interface EmailTemplateModel {
    emailTemplateID: number,
    templateName: string,
    templateDetail: string,
    templateSub: string,
    templateDescription: string,
    templateFor: string,
    createdBy: number,
    createdAt: string | null
}


export interface UserRequestFlow {
  id: number,
  label: string,  
  description: string,
  isActive: boolean,
  steps: UserRequestStep[],
  byUser: number,
  dirtyFields: string[]
}

export interface UserRequestStep {
  stepType: UserRequestFlowStepType,
  label: string,
  mailTo: string[],
  sendMail: boolean
}

export enum UserRequestFlowStepType {
  request, approveApprover, approveAdmin, createAdmin, createAuto
}